"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var hooks_1 = require("./hooks");
var Col_1 = __importDefault(require("./Col"));
var Responsive_1 = __importDefault(require("./Responsive"));
var Row = function (props) {
    var stretch = props.stretch, children = props.children, onRef = props.onRef, hasWrapper = props.hasWrapper;
    var responsiveLayout = hooks_1.getResponsiveLayout(props);
    var responsiveRule = hooks_1.useResponsiveStyle(responsiveLayout);
    return (react_1.default.createElement(Col_1.default, __assign({ flexDirection: "row", alignItems: stretch ? "stretch" : "center" }, props, { flexWrap: !!responsiveRule && responsiveRule.includes('%') ? 'wrap' : undefined, ref: onRef }), Boolean(!responsiveLayout || children === undefined) ? children : (react_1.default.createElement(Responsive_1.default, { hasWrapper: hasWrapper, rules: responsiveLayout }, children))));
};
exports.default = Row;
//# sourceMappingURL=Row.js.map